// extracted by mini-css-extract-plugin
export default {"textContainer":"ConfigFileView_textContainer__bUYON","closeButtonContainer":"ConfigFileView_closeButtonContainer__+namN"};